
<div class="header-toolbar">
  <h1>
    {{ dossier?.name }}
    <span>[Archivé]</span>
  </h1>
</div>

<form #form="ngForm" autocomplete="off" *ngIf="dossier">

  <!-- Toolbar -->
  <div class="main btn-toolbar">

    <div class="btn-group">    
      <div class="content">

        <a class="btn" [routerLink]="['/dossiers/archive']">
          <t-icon name="close"></t-icon>
          <span class="text">Annuler</span>
        </a>

      </div>
    </div>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="dossier">

    <div class="column">

      <div class="panel">
        <h2>Données</h2>

        <t-dossier-tree 
          [tree]="dossierTree"
        
          (selected)="selectItem($event)"
        ></t-dossier-tree>

      </div>
      
      <div *ngIf="mode === 'edit'" class="panel">
        <h2>Autres</h2>

        <div class="form-group">
          <label for="id">Identifiant</label>
          <span id="id" class="value">{{ dossier.id }}</span>
        </div>

        <div class="form-group">
          <label for="created_at">Date d'ajout</label>
          <span id="created_at" class="value">{{ dossier.created_at | tzdate }}</span>
        </div>

        <div class="form-group">
          <label for="created_by">Ajouté par</label>
          <span id="created_by" class="value">{{ dossier.created_by.fullname }}</span>
        </div>

        <div class="form-group">
          <label for="created_at">Date de modification</label>
          <span id="created_at" class="value">{{ dossier.updated_at | tzdate }}</span>
        </div>

        <div class="form-group">
          <label for="updated_by">Modifié par</label>
          <span id="updated_by" class="value">{{ dossier.updated_by.fullname }}</span>
        </div>
      </div>
      
    </div>

    <div class="column">

      <div class="panel" *ngIf="selectedRecordLink">
        <h2>Détails</h2>

        <t-record-link-form [link]="selectedRecordLink" [rootLink]="dossierTree.rootItem.link" (fixIssue)="selectRootItem()"></t-record-link-form>

      </div>


      <div class="panel" *ngIf="selectedDataLink">
        <h2>Détails</h2>

        <t-data-link-form [link]="selectedDataLink"></t-data-link-form>

      </div>

      <div class="panel" *ngIf="selectedLinkGroup">
        <h2>Détails</h2>

        <t-link-group-form [group]="selectedLinkGroup"></t-link-group-form>

      </div>
      

    </div>

  </div>
</form>